import { IResourceList } from 'src/components/challenge/ChallengeInterfaces';
import { ResourceTypeDetailEnum } from 'src/shared/enums';
import { IChallengeVideoSection } from 'src/shared/models';

const {
  VIDEO_SECTION_ID,
  VIDEO_SECTION_TYPE,
  VIDEO_SECTION_DESKTOP_IMAGE,
  VIDEO_SECTION_MOBILE_IMAGE,
  VIDEO_SECTION_DESCRIPTION,
  VIDEO_ASPECT_RATIO,
  UPLOAD_MEDIA_NEW,
} = ResourceTypeDetailEnum;

export const buildChallengeVideoSection = (
  resource: IResourceList,
): IChallengeVideoSection => {
  const { resourceDetailList } = resource;
  let item: IChallengeVideoSection;

  resourceDetailList
    .filter(({ status }) => status)
    .forEach(({ idResourceTypeD: { idResourceTypeD }, value }) => {
      switch (idResourceTypeD) {
        case VIDEO_SECTION_ID:
        case UPLOAD_MEDIA_NEW:
          item = {
            ...item,
            id: item?.id ? item?.id : value,
          };
          break;
        case VIDEO_SECTION_TYPE:
          item = {
            ...item,
            type: Number(value),
          };
          break;
        case VIDEO_SECTION_DESKTOP_IMAGE:
          item = {
            ...item,
            imgDesktop: value,
          };
          break;
        case VIDEO_SECTION_MOBILE_IMAGE:
          item = {
            ...item,
            imgMobile: value,
          };
          break;
        case VIDEO_SECTION_DESCRIPTION:
          item = {
            ...item,
            description: value,
          };
          break;
        case VIDEO_ASPECT_RATIO:
          item = {
            ...item,
            vertical: value === 'true',
          };
          break;
      }
    });

  return item;
};
